/**
 * Lightweight scroll-reveal + count-up animation.
 * - Reveals top-level sections as they enter the viewport (skips the first/hero section).
 * - Animates elements with [data-counter-target] from 0 to their target value once visible.
 * Respects prefers-reduced-motion.
 */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealSections() {
    const sections = Array.from(document.querySelectorAll('main .shopify-section'));
    // Skip the first section (hero) - it has its own load-in animation.
    sections.slice(1).forEach((el) => el.setAttribute('data-scroll-reveal', ''));

    if (reduceMotion) {
      sections.forEach((el) => el.setAttribute('data-inview', ''));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-inview', '');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    sections.slice(1).forEach((el) => observer.observe(el));
  }

  function animateCount(el) {
    const target = parseFloat(el.getAttribute('data-counter-target') || '0');
    const decimals = (el.getAttribute('data-counter-target') || '').includes('.')
      ? el.getAttribute('data-counter-target').split('.')[1].length
      : 0;
    const duration = 1600;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = target * eased;
      el.textContent = value.toFixed(decimals);
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = target.toFixed(decimals);
      }
    }

    requestAnimationFrame(tick);
  }

  function setupCounters() {
    const counters = Array.from(document.querySelectorAll('[data-counter-target]'));
    if (counters.length === 0) return;

    if (reduceMotion) {
      counters.forEach((el) => {
        el.textContent = el.getAttribute('data-counter-target');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    counters.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      revealSections();
      setupCounters();
    });
  } else {
    revealSections();
    setupCounters();
  }
})();
